import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ShippingMethodApiModel } from '../ShippingMethodApiModel'

export const ShippingMethodApiModelStub =
  Factory.Sync.makeFactory<ShippingMethodApiModel>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.words()),
    active: true,
    description: Factory.each(() => faker.random.words()),
  })
